import { Box } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import NoDataImg from "../../assets/images/empty-state/no-data.svg";
import useStyles from "./styles";

const NoDataFound = ({
  nodataText,
  noDataCustomImg,
  otherElement,
  largeFont,
  lightFont,
  boldFont,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      className={`${classes.noDataImg} no-data-img`}
      height="100%"
    >
      <img
        alt="No data icon"
        src={noDataCustomImg ? noDataCustomImg : NoDataImg}
      />
      <p
        className={`${largeFont ? "font-20" : "font-13"} ${
          lightFont ? "f-light-gray" : ""
        } ${boldFont ? "font-bold" : ""}`}
      >
        {nodataText ? nodataText : t("text.noDataFound")}
      </p>
      {otherElement}
    </Box>
  );
};

export default NoDataFound;
